import { render } from "./dot.vue?vue&type=template&id=2705d494"
import script from "./dot.vue?vue&type=script&lang=js"
export * from "./dot.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__